import { render, staticRenderFns } from "./Planning.vue?vue&type=template&id=2dd1287a"
import script from "./Planning.vue?vue&type=script&lang=js"
export * from "./Planning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dd1287a')) {
      api.createRecord('2dd1287a', component.options)
    } else {
      api.reload('2dd1287a', component.options)
    }
    module.hot.accept("./Planning.vue?vue&type=template&id=2dd1287a", function () {
      api.rerender('2dd1287a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/Planning.vue"
export default component.exports